import Lenis from 'https://cdn.jsdelivr.net/npm/lenis@1.1.18/+esm';

// Respect user's accessibility preferences
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  // CRITICAL FIX: Disable native smooth scroll which conflicts with Lenis
  const style = document.createElement('style');
  style.innerHTML = `
    html, html.lenis, html.lenis body {
      scroll-behavior: auto !important;
      height: auto;
    }
    .lenis.lenis-smooth { scroll-behavior: auto !important; }
    .lenis.lenis-stopped { overflow: hidden; }
    .lenis.lenis-scrolling iframe { pointer-events: none; }
    .lenis.lenis-smooth [data-lenis-prevent] { overscroll-behavior: contain; }
  `;
  document.head.appendChild(style);

  // Add Lenis classes to html/body
  document.documentElement.classList.add('lenis', 'lenis-smooth');

  // Force manual scroll restoration to prevent browser jumping
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 2,
    infinite: false,
    autoResize: true,
    syncTouch: true,
    syncTouchLerp: 0.075,
  });

  // Animation frame loop
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Add data-lenis-prevent to all scrollable containers
  const scrollableContainers = document.querySelectorAll(
    '.v-scrollable, .drawer, .modal, cart-drawer, menu-drawer, .mega-menu, [role="dialog"], .quick-view, drawer-component, modal-component'
  );
  scrollableContainers.forEach(el => {
    if (el) el.setAttribute('data-lenis-prevent', '');
  });

  // Resize observer for dynamic content
  const resizeObserver = new ResizeObserver(() => {
    setTimeout(() => lenis.resize(), 100);
  });
  resizeObserver.observe(document.body);

  // Resize after images and dynamic content load
  window.addEventListener('load', () => {
    setTimeout(() => lenis.resize(), 500);
    // Extra resize calls for product pages with sticky elements and lazy images
    setTimeout(() => lenis.resize(), 1000);
    setTimeout(() => lenis.resize(), 2000);
    setTimeout(() => lenis.resize(), 3000);
  });

  // Watch for dynamically added content
  const mainContent = document.querySelector('#MainContent') || document.body;
  const contentObserver = new MutationObserver(() => {
    setTimeout(() => lenis.resize(), 100);
  });
  contentObserver.observe(mainContent, { childList: true, subtree: true });

  // Resize on window resize
  window.addEventListener('resize', () => {
    setTimeout(() => lenis.resize(), 100);
  });

  // Handle images loading (important for product pages)
  document.querySelectorAll('img').forEach(img => {
    if (!img.complete) {
      img.addEventListener('load', () => {
        setTimeout(() => lenis.resize(), 100);
      });
    }
  });

  // Handle lazy loaded images
  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => lenis.resize(), 200);
        }
      });
    });
    document.querySelectorAll('img[loading="lazy"]').forEach(img => {
      imgObserver.observe(img);
    });
  }

  // Expose to window for debugging
  window.lenis = lenis;

  console.log('Lenis smooth scroll initialized');
}
